import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { ReactElement, useContext } from "react";

import { CollectionAssetsContext } from "../../../../providers/collection-assets-provider";
import { DEFAULT_LIMITS } from "../../../../sections/files/file-list-operators";

export default function CollectionItemsLimitSelector(): ReactElement {
  const { limit, setLimit, setPage } = useContext(CollectionAssetsContext);

  function internalChangeLimit(limit: number): void {
    setPage(1);
    setLimit(limit);
  }

  return (
    <FormControl className="w-[110px]">
      <InputLabel className="top-[16px]">Show</InputLabel>
      <Select
        sx={{
          "& .MuiOutlinedInput-notchedOutline": { border: 0 },
          "& legend span": { width: 0, padding: 0 },
          "& .MuiSelect-select": {
            paddingTop: "25px",
            paddingBottom: "8px",
          },
        }}
        className="shadow rounded-[15px] bg-white overflow-hidden h-full border-none"
        value={limit.toString()}
        onChange={(v) => internalChangeLimit(parseInt(v.target.value))}
        label="Show"
      >
        {DEFAULT_LIMITS.map((v) => (
          <MenuItem key={v} value={v}>
            {v}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
